import script from "./SfxDialogHttp408.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxDialogHttp408.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
